import { Building2, Phone, Home, Volume2, VolumeX, AudioLines } from "lucide-react";
import { RANKS, indefinite } from "@/lib/progression";

const MODALITY_ICON = {
  "In-person": Building2,
  "Phone": Phone,
  "Shelter intake": Home,
};

export const CaseHeader = ({ scenario, rank, timeLow, safetyCritical, autoNarrate, soundOn, onToggleNarrate, onToggleSound }) => {
  const ModIcon = MODALITY_ICON[scenario.modality] || Building2;
  return (
    <>
      <div className="flex flex-wrap items-center gap-3 mb-2">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800">
          <ModIcon className="h-3.5 w-3.5" /> {scenario.modality}
        </span>
        <h1 data-testid="case-title" className="font-heading text-lg font-semibold text-stone-800">{scenario.title}</h1>
        {timeLow && (
          <span data-testid="time-low-warning" className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">
            Time running low
          </span>
        )}
        {safetyCritical && (
          <span data-testid="safety-critical-warning" className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-rose-100 text-rose-800">
            Safety critical
          </span>
        )}
        <button
          data-testid="narrate-toggle"
          onClick={onToggleNarrate}
          aria-pressed={autoNarrate}
          title={autoNarrate ? "Turn off auto-narration" : "Read each scene aloud automatically"}
          className={`ml-auto inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors duration-200 ${
            autoNarrate
              ? "border-emerald-600 bg-emerald-50 text-emerald-800"
              : "border-stone-200 bg-white text-stone-500 hover:border-emerald-500 hover:text-emerald-800"
          }`}
        >
          <AudioLines className="h-3.5 w-3.5" />
          {autoNarrate ? "Auto-narrate on" : "Auto-narrate off"}
        </button>
        <button
          data-testid="ambience-toggle"
          onClick={onToggleSound}
          aria-pressed={soundOn}
          title={soundOn ? "Mute ambient sound" : "Enable ambient sound"}
          className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-white px-3 py-1.5 text-xs font-medium text-stone-500 hover:border-emerald-500 hover:text-emerald-800 transition-colors duration-200"
        >
          {soundOn ? <Volume2 className="h-3.5 w-3.5" /> : <VolumeX className="h-3.5 w-3.5" />}
          {soundOn ? "Ambience on" : "Ambience off"}
        </button>
      </div>
      <p data-testid="rank-intro" className="mb-6 text-sm text-stone-500">
        As {indefinite(RANKS[rank].title)} {RANKS[rank].title}, you are covering this case. Every choice shapes the outcome.
      </p>
    </>
  );
};
